// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1,h2,h3,h4,h5,h6,p,span,a,i{
  padding: 0px;
  margin: 0px;
}

p,span,a,i{
  font-size: 0.9rem;
}

:root{
  --bs-modal-width: fit-content !important;
}

.App {

}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@font-face {
  font-family: Lato;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

h1,h2,h3,h4,h5,h6,p,span,a{
  font-family: Lato;
}

.iminio-border-round{
  border-radius: 25px;
}
.iminio-border-round-force,
.iminio-border-round-force > *{
  border-radius: 25px !important;
}

.iminio-button:hover{
    filter: brightness(1.1)
}

.iminio-password-show-button{
  position: absolute;
  right: 20px;
  top: 0px;
  background-color: transparent;
  width: 24px;
  border: none !important;
  opacity: 70%;
}
.iminio-password-show-button:hover,
.iminio-password-show-button:active,
.iminio-password-show-button:focus,
.iminio-password-show-button:focus-visible,
.iminio-password-show-button.btn-check:checked{
  background-color: transparent !important;
}

.width-100{
  width: 100% !important;
}

.corner-round{
  border-radius: 25px
}

.text-6 { font-size: 0.6rem; }
.text-7 { font-size: 0.7rem; }
.text-8 { font-size: 0.8rem; }
.text-9 { font-size: 0.9rem; }
.text-10 { font-size: 1.0rem; }
.text-11 { font-size: 1.1rem; }
.text-12 { font-size: 1.2rem; }
.text-13 { font-size: 1.3rem; }
.text-14 { font-size: 1.4rem; }
.text-15 { font-size: 1.5rem; }
.text-16 { font-size: 1.6rem; }
.text-17 { font-size: 1.7rem; }
.text-18 { font-size: 1.8rem; }
.text-19 { font-size: 1.9rem; }
.text-20 { font-size: 2.0rem; }
.text-21 { font-size: 2.1rem; }
.text-22 { font-size: 2.2rem; }
.text-23 { font-size: 2.3rem; }
.text-24 { font-size: 2.4rem; }
.text-25 { font-size: 2.5rem; }
.text-26 { font-size: 2.6rem; }
.text-27 { font-size: 2.7rem; }
.text-28 { font-size: 2.8rem; }
.text-29 { font-size: 2.9rem; }
.text-30 { font-size: 3.0rem; }
.text-31 { font-size: 3.1rem; }
.text-32 { font-size: 3.2rem; }
.text-33 { font-size: 3.3rem; }
.text-34 { font-size: 3.4rem; }
.text-35 { font-size: 3.5rem; }
.text-36 { font-size: 3.6rem; }
.text-38 { font-size: 3.8rem; }
.text-40 { font-size: 4.0rem; }
.text-42 { font-size: 4.2rem; }
.text-44 { font-size: 4.4rem; }
.text-46 { font-size: 4.6rem; }
.text-48 { font-size: 4.8rem; }
.text-50 { font-size: 5rem; }
.text-52 { font-size: 5.2rem; }
.text-54 { font-size: 5.4rem; }

.divider-v{
  background-color: var(--clr-gray-darker);
  width: 1px !important;
  height: 100%;
}

.divider-h{
  background-color: var(--clr-gray-darker);
  width: 100% !important;
  height: 1px;
}

/*   OVERRIDES    */
.row, .row > * {
  padding-left: 0px;
  padding-right: 0px;
  margin: 0px;
}

.form-control:focus{
  border-color: var(--clr-blue) !important;
  border-width: 1px !important;
  box-shadow: 0 0 0 0.2rem var(--clr-blue);
}

.nav-link:focus, .nav-link:hover{
  color: var(--clr-white-base) !important;
}

.col{
  flex-direction: column !important;
}

.accordion-button{
  padding: 0.6rem 1rem;
}
.accordion-button:after{
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-family:"Material Design Icons";
  width: 1rem;
  height: 0.6rem;
  background-image: none;
  content: "\\F0140";
}
.accordion-button:not(.collapsed)::after{
  background-image: none;
  content: "\\F0140";
}

.animation-fade-in-up{
  animation-name: fade-in-up-animation;
  animation-duration: 1.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-delay: 500ms;
  transform: translate(0px, 15%);
  filter: opacity(0);
}

.iminio-upload-foto-input{
  border: 3px solid var(--clr-gray-darker);
  min-height: 78px;
  max-width: 240px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.iminio-upload-foto-input:hover{
  cursor: pointer;
  filter: brightness(1.05);
}
.iminio-upload-foto-input-text{
  transform: translate(0px, -15px);
}

iframe{
  display: none !important;
}

.iminio-error-container{
  max-width: fit-content;
}

label{
  font-size: 0.9rem;
}

.react-datepicker__input-container > input{
  border: 1px solid #0002 !important;
  border-radius: 5px;
  padding: 6px;
}

.react-datepicker__input-container > input:disabled{
  background-color: var(--bs-secondary-bg);
}

@keyframes fade-in-up-animation{
  0%{
    transform: translate(0px, 15%);
    filter: opacity(0);
  }
  100%{
    transform: translate(0px, 0%);
    filter: opacity(100);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;AAEA;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,4CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;AACA;;EAEE,8BAA8B;AAChC;;AAEA;IACI;AACJ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,6BAA6B;EAC7B,WAAW;EACX,uBAAuB;EACvB,YAAY;AACd;AACA;;;;;EAKE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA,UAAU,iBAAiB,EAAE;AAC7B,UAAU,iBAAiB,EAAE;AAC7B,UAAU,iBAAiB,EAAE;AAC7B,UAAU,iBAAiB,EAAE;AAC7B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,eAAe,EAAE;AAC5B,WAAW,iBAAiB,EAAE;AAC9B,WAAW,iBAAiB,EAAE;;AAE9B;EACE,wCAAwC;EACxC,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;EACnC,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;EACA;IACE,6BAA6B;IAC7B,oBAAoB;EACtB;AACF","sourcesContent":["h1,h2,h3,h4,h5,h6,p,span,a,i{\n  padding: 0px;\n  margin: 0px;\n}\n\np,span,a,i{\n  font-size: 0.9rem;\n}\n\n:root{\n  --bs-modal-width: fit-content !important;\n}\n\n.App {\n\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@font-face {\n  font-family: Lato;\n  src: url('/public/fonts/Lato-Regular.ttf');\n}\n\nh1,h2,h3,h4,h5,h6,p,span,a{\n  font-family: Lato;\n}\n\n.iminio-border-round{\n  border-radius: 25px;\n}\n.iminio-border-round-force,\n.iminio-border-round-force > *{\n  border-radius: 25px !important;\n}\n\n.iminio-button:hover{\n    filter: brightness(1.1)\n}\n\n.iminio-password-show-button{\n  position: absolute;\n  right: 20px;\n  top: 0px;\n  background-color: transparent;\n  width: 24px;\n  border: none !important;\n  opacity: 70%;\n}\n.iminio-password-show-button:hover,\n.iminio-password-show-button:active,\n.iminio-password-show-button:focus,\n.iminio-password-show-button:focus-visible,\n.iminio-password-show-button.btn-check:checked{\n  background-color: transparent !important;\n}\n\n.width-100{\n  width: 100% !important;\n}\n\n.corner-round{\n  border-radius: 25px\n}\n\n.text-6 { font-size: 0.6rem; }\n.text-7 { font-size: 0.7rem; }\n.text-8 { font-size: 0.8rem; }\n.text-9 { font-size: 0.9rem; }\n.text-10 { font-size: 1.0rem; }\n.text-11 { font-size: 1.1rem; }\n.text-12 { font-size: 1.2rem; }\n.text-13 { font-size: 1.3rem; }\n.text-14 { font-size: 1.4rem; }\n.text-15 { font-size: 1.5rem; }\n.text-16 { font-size: 1.6rem; }\n.text-17 { font-size: 1.7rem; }\n.text-18 { font-size: 1.8rem; }\n.text-19 { font-size: 1.9rem; }\n.text-20 { font-size: 2.0rem; }\n.text-21 { font-size: 2.1rem; }\n.text-22 { font-size: 2.2rem; }\n.text-23 { font-size: 2.3rem; }\n.text-24 { font-size: 2.4rem; }\n.text-25 { font-size: 2.5rem; }\n.text-26 { font-size: 2.6rem; }\n.text-27 { font-size: 2.7rem; }\n.text-28 { font-size: 2.8rem; }\n.text-29 { font-size: 2.9rem; }\n.text-30 { font-size: 3.0rem; }\n.text-31 { font-size: 3.1rem; }\n.text-32 { font-size: 3.2rem; }\n.text-33 { font-size: 3.3rem; }\n.text-34 { font-size: 3.4rem; }\n.text-35 { font-size: 3.5rem; }\n.text-36 { font-size: 3.6rem; }\n.text-38 { font-size: 3.8rem; }\n.text-40 { font-size: 4.0rem; }\n.text-42 { font-size: 4.2rem; }\n.text-44 { font-size: 4.4rem; }\n.text-46 { font-size: 4.6rem; }\n.text-48 { font-size: 4.8rem; }\n.text-50 { font-size: 5rem; }\n.text-52 { font-size: 5.2rem; }\n.text-54 { font-size: 5.4rem; }\n\n.divider-v{\n  background-color: var(--clr-gray-darker);\n  width: 1px !important;\n  height: 100%;\n}\n\n.divider-h{\n  background-color: var(--clr-gray-darker);\n  width: 100% !important;\n  height: 1px;\n}\n\n/*   OVERRIDES    */\n.row, .row > * {\n  padding-left: 0px;\n  padding-right: 0px;\n  margin: 0px;\n}\n\n.form-control:focus{\n  border-color: var(--clr-blue) !important;\n  border-width: 1px !important;\n  box-shadow: 0 0 0 0.2rem var(--clr-blue);\n}\n\n.nav-link:focus, .nav-link:hover{\n  color: var(--clr-white-base) !important;\n}\n\n.col{\n  flex-direction: column !important;\n}\n\n.accordion-button{\n  padding: 0.6rem 1rem;\n}\n.accordion-button:after{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  font-family:\"Material Design Icons\";\n  width: 1rem;\n  height: 0.6rem;\n  background-image: none;\n  content: \"\\F0140\";\n}\n.accordion-button:not(.collapsed)::after{\n  background-image: none;\n  content: \"\\F0140\";\n}\n\n.animation-fade-in-up{\n  animation-name: fade-in-up-animation;\n  animation-duration: 1.5s;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards;\n  animation-delay: 500ms;\n  transform: translate(0px, 15%);\n  filter: opacity(0);\n}\n\n.iminio-upload-foto-input{\n  border: 3px solid var(--clr-gray-darker);\n  min-height: 78px;\n  max-width: 240px;\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.iminio-upload-foto-input:hover{\n  cursor: pointer;\n  filter: brightness(1.05);\n}\n.iminio-upload-foto-input-text{\n  transform: translate(0px, -15px);\n}\n\niframe{\n  display: none !important;\n}\n\n.iminio-error-container{\n  max-width: fit-content;\n}\n\nlabel{\n  font-size: 0.9rem;\n}\n\n.react-datepicker__input-container > input{\n  border: 1px solid #0002 !important;\n  border-radius: 5px;\n  padding: 6px;\n}\n\n.react-datepicker__input-container > input:disabled{\n  background-color: var(--bs-secondary-bg);\n}\n\n@keyframes fade-in-up-animation{\n  0%{\n    transform: translate(0px, 15%);\n    filter: opacity(0);\n  }\n  100%{\n    transform: translate(0px, 0%);\n    filter: opacity(100);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
